import { httpClient } from '../utils/httpClient';
import { Grado } from '../types/usuario.types';
import { GradoPayload } from '../types/grado.types';

// ============================================================
// gradoService.ts
// httpClient extrae body.data y lanza Error(body.message)
// si success === false.
// ============================================================

export const gradoService = {

  async listar(): Promise<Grado[]> {
    return httpClient.get<Grado[]>('/grados');
  },

  async obtener(id: number): Promise<Grado> {
    return httpClient.get<Grado>(`/grados/${id}`);
  },

  async crear(payload: GradoPayload): Promise<Grado> {
    return httpClient.post<Grado>('/grados', payload);
  },

  async modificar(id: number, payload: GradoPayload): Promise<Grado> {
    return httpClient.put<Grado>(`/grados/${id}`, payload);
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/grados/${id}`);
  },
};
